import { examAdminOpenApiClient } from "../generated/client";
import type { operations } from "@airange/generated-contracts/exam";
import { unwrapOpenApiResult } from "./openapi-result";

type RoleCatalogGet =
  operations["get_application_role_catalog_api_platform_applications__app_key__role_catalog_get"];
type SystemConfigGet = operations["get_system_config_api_system_config_get"];
type PublicSystemConfigGet = operations["get_public_system_config_api_system_public_config_get"];
type SystemCapabilitiesGet = operations["get_system_capabilities_api_system_capabilities_get"];
type SystemSettingsGet = operations["get_system_settings_api_system_settings_get"];
type SiteSettingsUpdatePost = operations["update_site_settings_api_system_settings_site_post"];
type SecuritySettingsUpdatePost = operations["update_security_settings_api_system_settings_security_post"];
type JudgeSettingsUpdatePost = operations["update_judge_settings_api_system_settings_judge_post"];
type StorageSettingsUpdatePost = operations["update_storage_settings_api_system_settings_storage_post"];
type IntegrationSettingsUpdatePost =
  operations["update_integration_settings_api_system_settings_integration_post"];

export type RoleCatalogResponse = RoleCatalogGet["responses"][200]["content"]["application/json"];
export type RoleCatalogItem = RoleCatalogResponse["roles"][number];
export type SystemConfig = SystemConfigGet["responses"][200]["content"]["application/json"];
export type PublicSystemConfig = PublicSystemConfigGet["responses"][200]["content"]["application/json"];
export type SystemCapabilities = SystemCapabilitiesGet["responses"][200]["content"]["application/json"];
export type SiteSettings = SiteSettingsUpdatePost["responses"][200]["content"]["application/json"];
export type SecuritySettings = SecuritySettingsUpdatePost["responses"][200]["content"]["application/json"];
export type JudgeSettings = JudgeSettingsUpdatePost["responses"][200]["content"]["application/json"];
export type StorageSettings = StorageSettingsUpdatePost["responses"][200]["content"]["application/json"];
export type IntegrationSettings =
  IntegrationSettingsUpdatePost["responses"][200]["content"]["application/json"];
export type IntegrationSetting = IntegrationSettings[keyof IntegrationSettings];
export type SystemSettings = SystemSettingsGet["responses"][200]["content"]["application/json"];
export type SiteSettingsUpdatePayload = SiteSettingsUpdatePost["requestBody"]["content"]["application/json"];
export type SecuritySettingsUpdatePayload =
  SecuritySettingsUpdatePost["requestBody"]["content"]["application/json"];
export type JudgeSettingsUpdatePayload = JudgeSettingsUpdatePost["requestBody"]["content"]["application/json"];
export type StorageSettingsUpdatePayload =
  StorageSettingsUpdatePost["requestBody"]["content"]["application/json"];
export type IntegrationSettingsUpdatePayload =
  IntegrationSettingsUpdatePost["requestBody"]["content"]["application/json"];

export async function getSystemConfig() {
  return unwrapOpenApiResult(await examAdminOpenApiClient.GET("/api/system/config"));
}

export async function getSystemCapabilities() {
  return unwrapOpenApiResult(await examAdminOpenApiClient.GET("/api/system/capabilities"));
}

export async function getExamAdminRoleCatalog() {
  return unwrapOpenApiResult(
    await examAdminOpenApiClient.GET("/api/platform/applications/{app_key}/role-catalog", {
      params: { path: { app_key: "exam-admin" } },
    }),
  );
}

export async function getPublicSystemConfig() {
  return unwrapOpenApiResult(await examAdminOpenApiClient.GET("/api/system/public-config"));
}

export async function getSystemSettings() {
  return unwrapOpenApiResult(await examAdminOpenApiClient.GET("/api/system/settings"));
}

export async function updateSiteSettings(payload: SiteSettingsUpdatePayload) {
  return unwrapOpenApiResult(
    await examAdminOpenApiClient.POST("/api/system/settings/site", { body: payload }),
  );
}

export async function updateSecuritySettings(payload: SecuritySettingsUpdatePayload) {
  return unwrapOpenApiResult(
    await examAdminOpenApiClient.POST("/api/system/settings/security", { body: payload }),
  );
}

export async function updateJudgeSettings(payload: JudgeSettingsUpdatePayload) {
  return unwrapOpenApiResult(
    await examAdminOpenApiClient.POST("/api/system/settings/judge", { body: payload }),
  );
}

export async function updateStorageSettings(payload: StorageSettingsUpdatePayload) {
  return unwrapOpenApiResult(
    await examAdminOpenApiClient.POST("/api/system/settings/storage", { body: payload }),
  );
}

export async function updateIntegrationSettings(payload: IntegrationSettingsUpdatePayload) {
  return unwrapOpenApiResult(
    await examAdminOpenApiClient.POST("/api/system/settings/integration", { body: payload }),
  );
}
